// extracted by mini-css-extract-plugin
export default {"chartImage":"IsoPage_chartImage__VZ44T","box":"IsoPage_box__jUfaP"};